const getCatering = (cateringState) => cateringState.catering;
const getUsers = (usersState) => usersState.users;

export default {
  getCatering,
  getUsers,
};



// WEBPACK FOOTER //
// ./store/modules/catering/getters.js